<template>
	<div class="comp">
		<div class="compContent">
			<div class="title">
				<div class="titleL">医疗服务套餐详情</div>
				<div class="titleR">
					<el-button type="warning" plain size="small" @click="back">返回</el-button>
				</div>
			</div>
			<div class="content">
				<div class="msg">
					<div class="msgItem" style="width:30%">
						<div class="label">套餐名称:</div>
						<div class="value">
							{{detail.title}}
						</div>
					</div>
					<div class="msgItem">
						<div class="label">宠物类型:</div>
						<div class="value">
							<span v-if="detail.applyType==='2'">犬用</span>
							<span v-else-if="detail.applyType==='1'">猫用</span>
							<span v-else>通用</span>
						</div>
					</div>
					<div class="msgItem">
						<div class="label">分类:</div>
						<div class="value">
							{{detail.category_info&&detail.category_info.name}}
						</div>
					</div>
					<div class="msgItem" style="width:15%">
						<div class="label">总价:</div>
						<div class="value">
							<span style="font-weight: bold;font-size: 16px;">￥{{detail.total_money}}</span>
						</div>
					</div>
				</div>
				<div class="review">
					<el-table :data="detail.group_items" height="100%">
						<el-table-column label="编码">
							<template slot-scope="props">
								{{parseInt(props.$index+1)}}
							</template>
						</el-table-column>
						<el-table-column label="名称" prop="goods_name">
						</el-table-column>
						<el-table-column label="规格" prop="sku_name">
						</el-table-column>
						<el-table-column label="价格" prop="custom_price">
						</el-table-column>
						<el-table-column label="数量" >
							<template slot-scope="props">
								{{props.row.use_num}}
							</template>
						</el-table-column>
						<el-table-column label="用量" >
							<template slot-scope="props">
								{{props.row.out_num}}
							</template>
						</el-table-column>
						<el-table-column label="总金额" prop="custom_total_money" >
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
		<div class="settlement">
			<div class="settlementL">
				
			</div>
			<div class="settlementR">
				
			</div>
		</div>
		<!-- 添加套餐 -->
		<div v-if="dialogAddShop_state">
			<dialogAddShop :addShopState="dialogAddShop_state" :classType="apply_type?apply_type.value:'0'" :shopId="curShopId" :tree="[{id:'604323824335a2f958dc740a',children:[{id:'604323824335a2f958dc740f'}]}]" @closeOn="dialogAddShop_state=false" @submit="submit_dialogAddShop"></dialogAddShop>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return{
				detail:{}
			}
		},
		computed:{
			ylfwParams(){
				return this.$store.state.yiliaoxin.ylfwParams;
			},
		},
		watch:{
			
		},
		mounted(){
			this.detail = this.ylfwParams.curRow_package
		},
		methods: {
			// 返回
			back(){
				this.ylfwParams.type = 'packageList'
				this.$store.commit("yiliaoxin/set_ylfwParams",this.ylfwParams)
			},
			
		}
	}
</script>
<style scoped lang="scss">
	.comp{
		position: relative;height: 100%;padding-bottom:68px;box-sizing: border-box;
		.compContent{
			height: 100%;background-color: #fff;border-radius: 12px;overflow: auto;
			.title{
				display: flex;height: 47px;line-height: 27px;border-bottom:1px solid #f2f2f2;padding:10px 18px;box-sizing: border-box;
				.titleL{
					width:50%;font-size: 14px;font-weight: bold;
				}
				.titleR{
					width:50%;text-align: right;
					.titleRText{
						display: inline-block;font-size: 14px;color:$mainColor;margin-left: 40px;cursor: pointer;
					}
				}
			}
			.content{
				height: calc(100% - 47px);
				.msg{
					display: flex;flex-wrap: wrap;
					.msgItem{
						width:25%;display: flex;padding:23px 0;
						.label{
							font-size: 14px;color:$fontColor;width:100px;text-align: right;line-height: 32px;margin-right: 4px;
						}
						.value{
							font-size: 14px;color:$fontColor;line-height: 32px;
						}
					}
				}
				.review{
					height: calc(100% - 80px);
				}
			}
		}
		.settlement{
			position: absolute;bottom:0;width:100%;height:56px;background-color: #fff;border-radius: 12px 12px 0 0;display: flex;padding:12px 20px;box-sizing: border-box;
			.settlementL{
				width:40%;font-size: 14px;line-height: 32px;
			}
			.settlementR{
				width:60%;text-align: right;font-size: 14px;line-height: 32px;
				.text{
					color:$fontColor;font-size: 14px;padding:0px 24px 0;display: inline-block;margin-right: 20px;
				}
			}
			
		}
	}
</style>
